"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRegionalDropdownItemId = void 0;
const getRegionalDropdownItemId = (region) => {
    return `dropdown-item-${region}`;
};
exports.getRegionalDropdownItemId = getRegionalDropdownItemId;
//# sourceMappingURL=helpers.js.map